import { useEffect, useRef, useState } from 'react';
import PratusInput from '../../../../DesignSystems/New/PratusInput';
import { StylishNewButton } from '../../../../DesignSystems/New/StylishNewButton';
import { SharedIcon } from '../../../../SharedIcon/SharedIcon';
import classNames from 'classnames';
import {
  IncidentTactic,
  useEditIncidentTactic,
} from '../../../hooks/incidentTacticHooks';

type TacticItemProps = {
  item: IncidentTactic;
  selectedTactics: string[];
  setSelectedTactics: React.Dispatch<React.SetStateAction<string[]>>;
  setTacticPoints: React.Dispatch<
    React.SetStateAction<{ x: number; y: number; id: string }[]>
  >;
};

export const TacticItem: React.FC<TacticItemProps> = ({
  item,
  selectedTactics,
  setSelectedTactics,
  setTacticPoints,
}) => {
  const [editing, setEditing] = useState(false);
  const itemRef = useRef<HTMLDivElement | null>(null);
  const editTactic = useEditIncidentTactic();

  const handleEditTactic = (newDescription: string) => {
    editTactic.mutate({ ...item, description: newDescription });
  };

  const handleDeleteTactic = async () => {
    await editTactic.mutateAsync({
      ...item,
      archived: true,
    });
    setSelectedTactics((prev) => prev.filter((id) => id !== item.tactic_id));
  };
  const updatePoint1 = () => {
    if (
      selectedTactics &&
      item &&
      selectedTactics.includes(item.tactic_id) &&
      itemRef.current
    ) {
      const rect = itemRef.current.getBoundingClientRect();
      const toAdd = {
        x: rect.right,
        y: rect.top + rect.height / 2,
        id: item.tactic_id,
      };
      setTacticPoints((prev) => {
        if (!prev.find((p) => p.id === item.tactic_id)) {
          return [...prev, toAdd];
        }
        return prev.map((p) => {
          if (p.id === item.tactic_id) {
            return toAdd;
          }
          return p;
        });
      });
    } else {
      setTacticPoints((prev) => {
        return prev.filter((p) => p.id !== item.tactic_id);
      });
    }
  };

  useEffect(() => {
    if (!itemRef.current) return;
    let lastX: number | null = null;
    let lastY: number | null = null;
    const interval = setInterval(() => {
      const rect = itemRef.current?.getBoundingClientRect();
      if (!rect) return;
      if (rect.left !== lastX || rect.top !== lastY) {
        lastX = rect.left;
        lastY = rect.top;
        updatePoint1();
      }
    }, 20);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTactics, item, setTacticPoints]);

  return (
    <div className="mb-2" ref={itemRef}>
      <div
        role="button"
        className={classNames('pratus-collapsible-item tactic-item', {
          'align-items-start': editing,
          selected: selectedTactics?.includes(item?.tactic_id),
        })}
        onClick={() => {
          if (editing) return;
          if (selectedTactics?.includes(item.tactic_id)) {
            setSelectedTactics(
              selectedTactics.filter((id: string) => id !== item.tactic_id)
            );
            setTacticPoints([]);
          } else {
            setSelectedTactics([...selectedTactics, item.tactic_id]);
          }
        }}
      >
        {!editing ? (
          <>{item.description}</>
        ) : (
          <PratusInput
            defaultValue={item.description}
            showErrorContainer={false}
            className="flex-grow-1 me-2"
            onSave={(value) => {
              handleEditTactic(value);
              setEditing(false);
            }}
            onCancel={() => setEditing(false)}
          />
        )}
        <div>
          <StylishNewButton
            className="button--link"
            onClick={(e) => {
              e.stopPropagation();
              setEditing(!editing);
            }}
          >
            <SharedIcon iconName="edit" color="light" />
          </StylishNewButton>
          <StylishNewButton
            className="button--link"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteTactic();
            }}
          >
            <SharedIcon iconName="delete" color="light" />
          </StylishNewButton>
        </div>
      </div>
    </div>
  );
};
